import { Dispatch, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  CREATE_SUCURSAL_REQUEST,
  CREATE_SUCURSAL_SUCCESS,
  CREATE_SUCURSAL_FAILURE,
  FETCH_SUCURSALES_REQUEST,
  FETCH_SUCURSALES_SUCCESS,
  FETCH_SUCURSALES_FAILURE,
  FETCH_SUCURSAL_REQUEST,
  FETCH_SUCURSAL_SUCCESS,
  FETCH_SUCURSAL_FAILURE,
  UPDATE_SUCURSAL_REQUEST,
  UPDATE_SUCURSAL_SUCCESS,
  UPDATE_SUCURSAL_FAILURE,
  DELETE_SUCURSAL_REQUEST,
  DELETE_SUCURSAL_SUCCESS,
  DELETE_SUCURSAL_FAILURE,
  SET_SUCURSALES_PAGE,
  SET_SUCURSALES_LIMIT
} from '../../../constants/sucursales/sucursales';
import { message } from 'antd';
import { RootState } from '../../store/store';
import fetchWithIP from '../utils/FechHeaders';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const createSucursalRequest = () => ({
  type: CREATE_SUCURSAL_REQUEST
});

export const createSucursalSuccess = (data: any) => ({
  type: CREATE_SUCURSAL_SUCCESS,
  payload: data
});

export const createSucursalFailure = (error: string) => ({
  type: CREATE_SUCURSAL_FAILURE,
  payload: error
});

export const fetchSucursalesRequest = () => ({
  type: FETCH_SUCURSALES_REQUEST
});

export const fetchSucursalesSuccess = (data: any) => ({
  type: FETCH_SUCURSALES_SUCCESS,
  payload: data
});

export const fetchSucursalesFailure = (error: string) => ({
  type: FETCH_SUCURSALES_FAILURE,
  payload: error
});

export const fetchSucursalRequest = () => ({
  type: FETCH_SUCURSAL_REQUEST
});

export const fetchSucursalSuccess = (data: any) => ({
  type: FETCH_SUCURSAL_SUCCESS,
  payload: data
});

export const fetchSucursalFailure = (error: string) => ({
  type: FETCH_SUCURSAL_FAILURE,
  payload: error
});

export const updateSucursalRequest = () => ({
  type: UPDATE_SUCURSAL_REQUEST
});

export const updateSucursalSuccess = (data: any) => ({
  type: UPDATE_SUCURSAL_SUCCESS,
  payload: data
});

export const updateSucursalFailure = (error: string) => ({
  type: UPDATE_SUCURSAL_FAILURE,
  payload: error
});

export const deleteSucursalRequest = () => ({
  type: DELETE_SUCURSAL_REQUEST
});

export const deleteSucursalSuccess = (sucursalId: string) => ({
  type: DELETE_SUCURSAL_SUCCESS,
  payload: sucursalId
});

export const deleteSucursalFailure = (error: string) => ({
  type: DELETE_SUCURSAL_FAILURE,
  payload: error
});

export const setSucursalesPage = (page: number) => ({
  type: SET_SUCURSALES_PAGE,
  payload: page
});

export const setSucursalesLimit = (limit: number) => ({
  type: SET_SUCURSALES_LIMIT,
  payload: limit
});

export const createSucursal = (
  sucursalData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(createSucursalRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        'sucursales',
        {
          method: 'POST',
        },
        sucursalData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al crear la sucursal');
      }

      dispatch(createSucursalSuccess(data));
      message.success('Sucursal creada exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al crear la sucursal';
      dispatch(createSucursalFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchSucursales = (
  page: number = 1,
  limit: number = 10,
  search?: string,
  empresaId?: number
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchSucursalesRequest());

    try {
      let url = `sucursales?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      if (empresaId) {
        url += `&empresaId=${empresaId}`;
      }

      const response = await fetchWithIP(
        url,
        {
          method: 'GET',
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las sucursales');
      }

      dispatch(fetchSucursalesSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener las sucursales';
      dispatch(fetchSucursalesFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchSucursal = (
  sucursalId: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchSucursalRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `sucursales/${sucursalId}`,
        {
          method: 'GET',
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener la sucursal');
      }

      dispatch(fetchSucursalSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener la sucursal';
      dispatch(fetchSucursalFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const updateSucursal = (
  sucursalId: string,
  sucursalData: any
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(updateSucursalRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `sucursales/${sucursalId}`,
        {
          method: 'PUT',
        },
        sucursalData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar la sucursal');
      }

      dispatch(updateSucursalSuccess(data));
      message.success('Sucursal actualizada exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al actualizar la sucursal';
      dispatch(updateSucursalFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const deleteSucursal = (
  sucursalId: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(deleteSucursalRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `sucursales/${sucursalId}`,
        {
          method: 'DELETE',
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar la sucursal');
      }

      dispatch(deleteSucursalSuccess(sucursalId));
      message.success('Sucursal eliminada exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al eliminar la sucursal';
      dispatch(deleteSucursalFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};